<template>
	<div class="VideoContrast">
		<!-- 面包屑 -->
		<div class="Breadcrumb">
			<img src="@img/icon/ui_home_page_0.png" alt />
			<a @click="$router.push('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
			<a class="active">视频对比</a>
		</div>
		<!-- 内容 -->
		<div class="contain">
			<p class="title">视频对比</p>
			<div class="videoarea">
				<div style="width: 748px;">
					<video @timeupdate="timeUpdate1" width="748" height="420" id="video1" :controls="controlsval1"
						:src="videoinfo.video"></video>
					<h1 class="title">{{ videoinfo.name }}</h1>
					<p class="desc">{{ videoinfo.profile }}</p>
				</div>
				<div style="height:386px;width:1px;background:#FFA216"></div>
				<div style="position: relative" id="videoarea">
					<div v-show="videosrc">
						<video @timeupdate="timeUpdate2" width="748" height="420" :controls="controlsval2" src="ccc"
							id="video2" :disablePictureInPicture="true"></video>
						<div class="btns">
							<button @click="reupload" class="reupload">
								<img src="@img/icon/ui_upload.png" />重新上传
							</button>
						</div>
					</div>
					<div v-show="!videosrc" class="uploadarea">
						<input id="upload" class="upload" @change="change" type="file" />
						<div class="upload" type="file">
							<img src="@img/icon/ui_add.png" alt />
						</div>
						<p class="desc" style="margin-top:11px">上传要对比的mp4格式视频，大小不超过100m</p>
					</div>
					<div class="btns">
						<span>评估分数：{{score}}</span>
						<button @click="player">{{ isplaying ? '暂停对比' : '开始对比' }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VideoContrast",
	data() {
		return {
			// videosrc: 'C:\Users\jiuying\Documents\pro\立定跳远PC\src\assets\image\background\test.mp4',
			// videosrc: "test.mp4",
			videosrc: false,
			isplaying: false,
			videoplay: false,
			videoinfo: {},

			readytime1: 0,
			pausetime1: 0,
			readytime2: 0,
			pausetime2: 0,
			controlsval1: true,
			controlsval2: true,
			// videourl='...'&width='200'&height='200'
			videoparams: {
				videourl: "",
				width: 0,
				height: 0
			},
			score:0,//评估分数
		};
	},
	created() {
		this.$loading.hide();
		window.addEventListener('message', this.getFrameMsg)
		console.log('window', window);
		document
			.getElementById("video1")
			.addEventListener("ended", this.playEnd);
		document
			.getElementById("video2")
			.addEventListener("ended", this.playEnd);
		this.getBasicVideo();
	},

	destroyed() {
		let iframegetcore = document.getElementById('iframegetcore');
		iframegetcore.contentWindow.postMessage('end');
		window.removeEventListener('message', this.getFrameMsg, false)
	},
	methods: {
		getFrameMsg(e) {
			console.log('e', e);
			if (e.data.end) {
				var videoarea = document.getElementById('videoarea');
				videoarea.removeChild(videoarea.lastElementChild);
				this.score = this.score||'评估失败';
				this.$loading.hide();
			}
			if (e.data.score) {
				console.log('分数', e.data.score);
				if(e.data.score>this.score) this.score = e.data.score; 
			}
		},
		// 时间监听 获取视频播放时间点
		timeUpdate1(e) {
			this.pausetime1 = e.target.currentTime;
		},
		timeUpdate2(e) {
			this.pausetime2 = e.target.currentTime;
		},
		// 播放/暂停功能 不同播放状态下的controls、暂停时间赋值
		player() {
			const video1 = document.getElementById("video1");
			const video2 = document.getElementById("video2");
			if (!this.isplaying) {
				this.isplaying = true;
				this.controlsval1 = false;
				this.controlsval2 = false;
				video1.currentTime = this.readytime1;
				video2.currentTime = this.readytime2;
				video1.play();
				video2.play();
			} else {
				this.isplaying = false;
				this.controlsval1 = true,
					this.controlsval2 = true,
					this.readytime1 = this.pausetime1;
				this.readytime2 = this.pausetime2;
				video1.pause();
				video2.pause();
			}
		},
		// 结束事件监听 暂停的时间初始化
		playEnd() {
			const video1 = document.getElementById("video1");
			const video2 = document.getElementById("video2");
			this.isplaying = false;
			video1.pause();
			video2.pause();
			this.readytime1 = 0;
			this.readytime2 = 0;
			this.controlsval1 = true;
			this.controlsval2 = true;
		},
		reupload() {
			this.videosrc = false;
			window.URL.revokeObjectURL(document.getElementById("video2").src);
			//  修改值以生效input的change事件
			document.getElementById("upload").value = null;
		},
		// 切换视频后 视频相关时间处理
		async change(event) {
			console.log(event.target.files);
			console.log(event.target.files[0].type);
			if (event.target.files[0].type != "video/mp4") {
				this.$message.warning("所选视频内容需为mp4格式");
				return;
			}
			if (event.target.files[0].size > 100 * 1024 * 1024) {
				this.$message.warning("所选视频内容超出100兆");
				return;
			}
			let checkSizes = await this.checkSize(event.target.files);
			console.log('checkSizes', checkSizes);
			this.videoparams.width = checkSizes.videoWidth;
			this.videoparams.height = checkSizes.videoHeight;

			var objurl = URL.createObjectURL(event.target.files[0]);
			this.videoparams.videourl = objurl;
			console.log('this.videoparams', this.videoparams);

			this.getCore();

			document.getElementById("video2").src = objurl;

			// 暂停播放
			document.getElementById("video1").pause();
			document.getElementById("video2").pause();
			// 参照视频复位
			document.getElementById("video1").currentTime = 0;
			this.isplaying = false;
			this.videosrc = true;
		},
		async getBasicVideo() {
			const res = await this.$http.get("api/video/contrast");
			this.videoinfo = res.result;
		},


		// 获取视频参数
		// 1、创建虚拟DOM
		async checkSize(files, isVideo) {
			if (!files || !files[0]) return false
			const checktimevideo = document.getElementById('checktimevideo')
			if (checktimevideo) {
				document.body.removeChild(checktimevideo)
			}
			let doms
			if (!isVideo) {
				doms = document.createElement('video')
			} else {
				doms = document.createElement('audio')
			}
			const url = URL.createObjectURL(files[0])
			console.log(url)
			doms.src = url
			doms.id = 'checktimevideo'
			doms.style.display = 'none'
			document.body.appendChild(doms)
			return await this.gettime(doms);
		},
		// 2、由于loadedmetadata 是异步代码所以需要promise进行封装转换为同步代码执行
		gettime(doms) {
			// 3、计算尺寸比例需要使用到最大公约数进行计算
			const getGcd = function (a, b) {
				let n1, n2;
				if (a > b) {
					n1 = a;
					n2 = b;
				} else {
					n1 = b;
					n2 = a;
				}
				let remainder = n1 % n2;
				if (remainder === 0) {
					return n2;
				} else {
					return getGcd(n2, remainder)
				}
			}
			// 由于loadedmetadata 是异步代码所以需要promise进行封装转换为同步代码执行
			const promise = new Promise(resolve => {
				doms.addEventListener('loadedmetadata', e => {
					const gcd = getGcd(e.target.videoWidth, e.target.videoHeight);
					console.log(gcd)
					let obj = {
						videoWidth: doms.videoWidth, // 尺寸宽 --- 分辨率
						videoHeight: doms.videoHeight, // 尺寸高
						duration: e.target.duration, // 视频时长 1表示一秒
						ccbl: [e.target.videoWidth / gcd, e.target.videoHeight / gcd] // 计算尺寸比例
					}
					resolve(obj)
				})
			})
			return promise
		},


		// 获取分数
		async getCore() {
			this.score = 0;
			this.$loading.show();
			var frameCore = document.createElement('iframe');
			frameCore.src = `./corefromvideo/index.html?videourl=${this.videoparams.videourl}&width=${this.videoparams.width}&height=${this.videoparams.height}`;
			frameCore.style.display = "none";
			document.getElementById('videoarea').appendChild(frameCore);
		},

	},
};
</script>

<style lang="less" scoped>
.VideoContrast {
	overflow: auto;

	.Breadcrumb {
		width: 100%;
		position: fixed;
		height: 66px;
		background: #fff1d1;
		padding-left: 38px;
		display: flex;
		justify-content: start;
		z-index: 10;

		>img {
			height: 66px;
		}

		a {
			line-height: 66px;
			font-size: 25px;
			font-weight: 400;
			color: rgba(0, 0, 0, 0.45);
		}

		a.active {
			color: #ffa216;
		}
	}

	.contain {
		width: 1705px;
		margin: 0 auto;
		margin-top: 96px;

		>p.title {
			margin-top: 20px;
			font-size: 40px;
			line-height: 48px;
			font-weight: bold;
			color: #ffffff;
			-webkit-text-stroke: 2px #ffa216;
			border-left: 6px solid #ffa216;
			border-radius: 1px;
			padding-left: 16px;
			letter-spacing: 2px;
		}

		.videoarea {
			margin-top: 20px;
			display: flex;
			justify-content: space-between;

			h1.title {
				width: 180px;
				height: 40px;
				font-size: 30px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				line-height: 40px;
				color: #313131;
				opacity: 1;
			}

			p.desc {
				font-size: 22px;
				font-weight: 400;
				line-height: 22px;
				color: #313131;
				opacity: 0.5;
			}

			.upload {
				width: 748px;
				height: 420px;
				background: #f6dfc4;
				opacity: 0.75;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				>img {
					width: 126px;
					height: 126px;
				}
			}

			.uploadarea {
				position: relative;

				input {
					width: 100%;
					height: 420px;
					position: absolute;
					opacity: 0;
					z-index: 10;
				}
			}
		}

		.btns {
			margin-top: 19px;
			display: flex;
			justify-content: end;
			align-items: center;
			span{
				color: #ff9900;
				font-size: 25px;
			}
			button {
				width: 169px;
				height: 57px;
				font-size: 25px;
				font-family: PingFang SC;
				color: #ffffff;
				background: linear-gradient(to right, #fec937, #ff9900);
				text-shadow: 0px 1px 2px rgba(129, 35, 0, 0.3);
				border: none;
				border-radius: 4px;
				margin-left: 34px;

				>img {
					width: 20px;
					height: 20px;
					margin-right: 5px;
				}
			}

			button.reupload {
				width: 124px;
				height: 42px;
				color: #ffa216;
				border: 1px solid #ffa216;
				font-size: 18px;
				font-weight: 500;
				background: none;
			}
		}
	}
}
</style>
